import "./style.css";
import Product from "../Product";

const ProductList = ({ products, handleClick }) => {
  return (
    <div className="productListContainer">
      {products &&
        products.map((product) => (
          <Product key={product.id} handleClick={handleClick} product={product} />
        ))}
    </div>
  );
};

export default ProductList;
